import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-356e476a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto mt-10" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "menu-box bg-gray-100 pt-4 flex flex-col gap-2 px-2" }
const _hoisted_4 = { class: "w-full flex justify-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h-3 w-3 bg-green-400 rounded-full" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connected", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blink h-3 w-3 bg-red-500 rounded-full" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Disconnected", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "rounded-full px-8 py-2 border-2 border-gray-500 overflow-ellipsis overflow-hidden hover:bg-gray-300"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rounded-full px-8 py-2 border-2 border-gray-500 hover:bg-gray-300" }, "Create Profile", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t-4 py-3" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#change-name-avatar",
  class: "rounded-full px-8 py-2 border-2 border-gray-500 hover:bg-gray-300"
}, "Change Name and Avatar", -1))
const _hoisted_17 = {
  key: 0,
  class: "btn btn-xs btn-circle loading mr-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "rounded-full px-8 py-2 border-2 border-gray-500" }, "Menu 3", -1))
const _hoisted_21 = {
  style: {"scroll-snap-type":"none","scrollbar-width":"none"},
  class: "msg-box overflow-auto flex flex-col-reverse p-2"
}
const _hoisted_22 = { class: "border-2 rounded-md pl-5 pr-2 py-1 w-full flex" }
const _hoisted_23 = ["rows"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-center" }, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " send ")
  ])
], -1))
const _hoisted_25 = { class: "users-box bg-gray-100 overflow-auto pt-4 flex flex-col gap-2 px-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-3 h-3 bg-green-500 rounded-full" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold" }, "online users")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "font-bold ml-1 text-left" }
const _hoisted_30 = {
  id: "change-name-avatar",
  class: "modal"
}
const _hoisted_31 = { class: "modal-box" }
const _hoisted_32 = { class: "form-control" }
const _hoisted_33 = { class: "input-group flex" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name", -1))
const _hoisted_35 = { class: "input-group mt-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "whitespace-nowrap" }, "Profile image", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn"
}, "Close", -1))

import { ref, computed } from "vue";
import Msg from "@/components/Msg.vue";
import store from "../store";
import { connectMetamaskWallet } from "../Web3/web3";
import { connectWebsocket, sendMessage, closeWebsocket, changeNameAndAvatar } from "../WebSocket/index";
import * as apis from "@/apis";

// store.messages.appendMessage({
//   user: {
//     name: "Hades God",
//     imageUrl: "https://www.pngitem.com/pimgs/m/570-5708777_reborn-png-photo-katekyo-hitman-reborn-png-transparent.png",
//   },
//   message:
//     "Erat sed rebum stet diam clita gubergren sit. Clita et lorem dolores sanctus, dolor accusam sed ipsum sit amet stet, ea et dolore et elitr. Consetetur tempor invidunt sit sed lorem et diam sadipscing rebum. Sanctus et justo consetetur elitr lorem consetetur no, invidunt takimata elitr consetetur et sadipscing, voluptua voluptua duo invidunt et accusam at, vero stet magna aliquyam sea dolor nonumy clita. Dolor diam justo et sanctus. Voluptua erat amet diam magna. Labore et diam ut at ipsum amet et kasd diam, sea lorem consetetur sit aliquyam erat dolore ut sanctus diam. Sit et ipsum diam lorem et ipsum, et erat voluptua amet amet. Lorem erat duo sed et kasd kasd, nonumy est lorem clita gubergren justo, dolore gubergren consetetur magna et ipsum. Aliquyam duo sit takimata lorem. Accusam est diam sed elitr dolore erat no. Invidunt eirmod dolore vero rebum takimata invidunt, elitr clita kasd elitr est. Sed diam voluptua ipsum erat diam erat amet nonumy, kasd clita diam eos sed no stet, ipsum amet ipsum clita lorem lorem dolor dolor, gubergren et dolor stet aliquyam kasd erat, dolor et at kasd consetetur dolor. Sanctus sadipscing sit ut justo sit elitr ut. Invidunt ipsum invidunt at consetetur. Invidunt vero et vero elitr elitr diam justo consetetur. Sed amet est eos magna. Ipsum sed magna sadipscing aliquyam aliquyam. Ipsum magna diam vero diam et et. Dolore dolor ut sed et sadipscing. Diam et rebum amet sanctus rebum, sed voluptua elitr no diam. Dolores aliquyam dolore sanctus et dolores kasd amet voluptua. Sed eos justo et vero. Lorem sed gubergren diam vero dolores. Ipsum erat duo ipsum et dolores no, gubergren sit et erat sanctus elitr elitr takimata eirmod, labore nonumy sea amet gubergren ipsum magna nonumy et, est nonumy kasd stet dolor sed dolores. Labore lorem labore elitr dolores sit, amet aliquyam sed sed et rebum elitr sed sit, sit voluptua dolor dolore est tempor gubergren gubergren elitr sit, est ea takimata tempor erat et lorem. Eos voluptua erat sit voluptua kasd gubergren diam. Aliquyam eos rebum takimata duo tempor vero ipsum, et sea est labore eos. Stet nonumy eos nonumy no duo lorem sea, clita labore erat sed at et. Dolor eos at invidunt amet justo invidunt sit magna vero, labore justo sadipscing erat sit erat ut labore eirmod, sadipscing eos nonumy ut duo amet eirmod et, magna diam lorem sed est dolore. Sit est sed sed.",
// });
// store.messages.appendMessage({
//   user: {
//     name: "Hades God",
//     imageUrl: "https://www.pngitem.com/pimgs/m/570-5708777_reborn-png-photo-katekyo-hitman-reborn-png-transparent.png",
//   },
//   message: "Fermi né nondimeno e che seguitando lodato e seguitando noi.",
// });

// const input_row = ref<number>(1);

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const inputText = ref<string>("");
const inputRow = computed(() => {
  const matches = inputText.value.match(/\n/g);
  if (!matches) return 1;
  return matches.length + 1;
});

function onSubmit() {
  // const currentUser: IUser = {
  //   name: "HadesGod",
  //   imageUrl: "https://www.pngitem.com/pimgs/m/570-5708777_reborn-png-photo-katekyo-hitman-reborn-png-transparent.png",
  // };
  // store.messages.appendMessage({
  //   user: currentUser,
  //   message: inputText.value.trim(),
  // });
  if (inputText.value == "") return;
  sendMessage(inputText.value.trim());
  inputText.value = "";
}
function onEnter(event: KeyboardEvent) {
  if (event.key == "Enter" && event.shiftKey == false) {
    onSubmit();
  }
}
/**
 * @description prevent to add \n to textarea will cause add 1 more line before sent msg
 */
function onEnterKeydown(event: KeyboardEvent) {
  if (event.key == "Enter" && event.shiftKey == false) {
    event.preventDefault();
  }
}

async function onClickConnect() {
  await connectMetamaskWallet();
  await enterChatRoom();
}

async function enterChatRoom() {
  const acc = store.account.getAccount.value;
  if (acc && acc.wallet) {
    console.log("conecting...");
    connectWebsocket(acc.wallet);
  }
}

const inputName = ref<string>("");
const inputAvatar = ref<string>("");

async function onChangeNameAndAvatar(): Promise<void> {
  if (inputName.value == "") {
    return;
  }
  changeNameAndAvatar(inputName.value, inputAvatar.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(store).websocket.isConnected.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
          ]),
          (!_unref(store).account.getAccount.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "rounded-full px-8 py-2 border-2 border-gray-500 hover:bg-gray-600",
                onClick: onClickConnect
              }, " Connect "))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(store).account.getShotWalletAddress.value) + "... ", 1)),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          (_unref(store).websocket.isConnected.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "rounded-full px-8 py-2 border-2 border-gray-500 hover:bg-red-100",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeWebsocket) && _unref(closeWebsocket)(...args)))
              }, " Exit Chat room "))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "rounded-full px-8 py-2 border-2 border-gray-500 hover:bg-gray-300",
                onClick: enterChatRoom
              }, [
                (_unref(store).state.websocket.isConnecting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                  : _createCommentVNode("", true),
                (!_unref(store).state.websocket.isConnecting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Enter Chat room"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "Connecting"))
              ])),
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).messages.getMessages.value, (msg, index) => {
            return (_openBlock(), _createBlock(Msg, {
              key: index,
              "account-img-url": 
            msg.user.avatar
              ? msg.user.avatar
              : 'https://pbs.twimg.com/profile_images/1364121255264198661/ui7bhUAy_400x400.jpg'
          ,
              "account-name": msg.user.screename ? msg.user.screename : 'unknow',
              msg: msg.message
            }, null, 8, ["account-img-url", "account-name", "msg"]))
          }), 128))
        ]),
        _createElementVNode("form", {
          class: "text-box p-4",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputText).value = $event)),
              name: "text_field",
              type: "text",
              rows: _unref(inputRow),
              style: {"scroll-snap-type":"none"},
              class: "w-full outline-none resize-none",
              onKeyup: _cache[2] || (_cache[2] = ($event: any) => (onEnter($event))),
              onKeydown: _cache[3] || (_cache[3] = ($event: any) => (onEnterKeydown($event)))
            }, null, 40, _hoisted_23), [
              [_vModelText, inputText.value]
            ]),
            _hoisted_24
          ])
        ], 32),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).chatroom.getAllUsers.value, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex flex-row items-center justify-start"
            }, [
              _createElementVNode("img", {
                src: user.avatar,
                alt: "user-profile",
                width: "36",
                height: "36",
                style: {"width":"36px","height":"36px"},
                class: "rounded-full border-2 flex items-center justify-center"
              }, null, 8, _hoisted_28),
              _createElementVNode("div", _hoisted_29, _toDisplayString(user.screename), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputName).value = $event)),
                placeholder: "Enter your name",
                class: "input input-bordered w-full",
                type: "text"
              }, null, 512), [
                [_vModelText, inputName.value]
              ])
            ]),
            _createElementVNode("label", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputAvatar).value = $event)),
                placeholder: "Enter your profile url",
                class: "input input-bordered w-full",
                type: "text"
              }, null, 512), [
                [_vModelText, inputAvatar.value]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "modal-action flex justify-between" }, [
          _hoisted_37,
          _createElementVNode("a", {
            href: "#",
            class: "btn bg-gray-500",
            onClick: onChangeNameAndAvatar
          }, "OK")
        ])
      ])
    ])
  ], 64))
}
}

})